import PropTypes from 'prop-types';

import { formatImageInfoCardListData } from '@/utils/homepageUtils';
import ImageInfoCard from './ImageInfoCard';
import { BREAKPOINTS_LABELS } from '@/constants/gui';

const ImageInfoCardList = ({ data, breakpoint, lazy = false }) => (
  <div className={`image-info-card-list image-info-card-list-${breakpoint} tu-image-info-card-list`} data-test-id="image-info-card-list">
    {data?.espotsList?.map((item) => (
      <ImageInfoCard key={item._id} data={formatImageInfoCardListData(item.espot)} breakpoint={breakpoint} lazy={lazy} />
    ))}
  </div>
);

ImageInfoCardList.propTypes = {
  data: PropTypes.shape({
    espotsList: PropTypes.array
  }),
  breakpoint: PropTypes.oneOf(BREAKPOINTS_LABELS),
  lazy: PropTypes.bool
};

export default ImageInfoCardList;
